import { WImage } from 'components/atoms'
import styles from './CollezioneHeroSlide.module.sass'

interface Props {
  item: any
  className?: string
  index?: number
}

const CollezioneHeroSlide = (props: Props) => {
  const { item = undefined, index = 0, className = '' } = props

  return (
    item &&
    item?.url && (
      <div className={`${styles.root} ${className ? styles[className] : ''}`}>
        <WImage
          src={item.url}
          alt={item?.imageAlt}
          // title={item.alt}
          maxWidth={1920}
          maxHeight={600}
          objectFit="cover"
          priority={index === 0}
          loading={index === 0 ? 'eager' : 'lazy'}
        />
      </div>
    )
  )
}

export default CollezioneHeroSlide
